import {
  ExamAreaFilter,
  listExamAreas,
} from '@/data/services/examAreaServices';

export const examAreaQueries = {
  all: ['exam-areas'] as const,

  list: (filters: ExamAreaFilter = {}) => ({
    queryKey: [...examAreaQueries.all, 'list', { filters }] as const,
    queryFn: () => listExamAreas(filters),
  }),
};
